import EnrollmentVM from './enrollment-vm';
export default {
  init : function(node) {
    var validationOptions = _.extend(Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, { insertMessages: false });

    var user_profile_data = JSON.parse($('#user_profile_json').val());
    $.extend(user_profile_data.profile, {current_password: null, password: null, password_confirmation: null});
    var dropdownValuesData = JSON.parse($('#dropdown_values_json').val());
    var forCreditInfoData = JSON.parse($('#for_credit_info_json').val());
    var redirect = $('#redirect_to').val();
    ko.applyBindingsWithValidation(new EnrollmentVM(user_profile_data, dropdownValuesData, redirect, forCreditInfoData), node, validationOptions);
  }
};
